<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid
        :items="workProjectTypeGrid"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <ProjectTypeModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_project_types',
              })
            "
            :create="true"
          />
        </template>
        <ProjectTypeTable :workProjectTypeGrid="workProjectTypeGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ProjectTypeTable from 'components/setting/projectType/ProjectTypeTable'
import ProjectTypeModal from 'components/setting/projectType/ProjectTypeModal'

export default {
  name: 'SettingProjectType',
  components: {
    ProjectTypeTable,
    ProjectTypeModal,
  },
  data() {
    return {
      selected: 1,
    }
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workProjectType', ['workProjectTypeGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workProjectType', ['onWorkProjectTypeGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkProjectTypeGrid(data)
    },
  },
}
</script>
